/* Mobielfabriq reparatie-wizard — 1-op-1 RepairPlugin-flow.
   Data: mf-rp-index.json + mf-rp-models-<cat>-<merk>.json (lazy fetch).
   Afspraak: ingebed contactformulier in stap 3 -> Shopify contactform (/contact)
   stuurt naam/telefoon/e-mail/opmerking + toestel/reparatie/variant/prijs naar
   het winkel-mailadres. Geen redirect, geen dubbele stappen. */
(function () {
  'use strict';

  function init(root) {
    var indexUrl = root.getAttribute('data-index-url');
    var waNumber = root.getAttribute('data-whatsapp') || '31639211212';
    var offerEmail = root.getAttribute('data-offer-email') || 'info@mobielfabriq.nl';
    var formKey = (root.getAttribute('data-form-key') || '').trim();
    var apptWebhook = (root.getAttribute('data-appt-webhook') || '').trim();
    var assetBase = indexUrl.replace(/mf-rp-index\.json.*$/, '');
    var body = root.querySelector('[data-rp-body]');
    var toastEl = root.querySelector('[data-rp-toast]');

    var idx = null;            // index-data (categorieën, merken)
    var brandCache = {};       // file -> data
    var st = {
      step: 1, sub: 'types',   // sub: types | brands | models
      cat: null, brand: null, brandFile: null,
      model: null,             // model-object uit brand-bestand
      color: null,
      btw: true,
      showAll: false,
      items: [],               // {rid, rname, opt, price, dur}
      service: null            // 'winkel' | 'verstuur'
    };

    /* ---------- helpers ---------- */
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function imgUrl(p) {
      if (!p) return '';
      if (p.charAt(0) === '$') return (idx && idx.base ? idx.base : '') + p.slice(1);
      return p;
    }
    // Prijzen in de data zijn incl. 21% BTW (zoals op mobielfabriq.nl)
    function displayPrice(p) { return st.btw ? p : p / 1.21; }
    function fmt(p) {
      var v = displayPrice(p);
      var euros = Math.floor(v);
      var cents = Math.round((v - euros) * 100);
      if (cents === 100) { euros += 1; cents = 0; }
      return { e: euros, c: (cents < 10 ? '0' : '') + cents };
    }
    function fmtFlat(p) { var f = fmt(p); return '€' + f.e + ',' + f.c; }
    function toast(msg) {
      toastEl.innerHTML = 'ⓘ ' + esc(msg) + '<button type="button" aria-label="Sluiten">✕</button>';
      toastEl.hidden = false;
      toastEl.querySelector('button').addEventListener('click', function () { toastEl.hidden = true; });
      clearTimeout(toastEl._t);
      toastEl._t = setTimeout(function () { toastEl.hidden = true; }, 5000);
    }
    function stepper() {
      root.querySelectorAll('[data-step-dot]').forEach(function (el) {
        var n = Number(el.getAttribute('data-step-dot'));
        el.classList.toggle('is-active', n === st.step);
        el.classList.toggle('is-done', n < st.step);
      });
    }
    function subtotal() { return st.items.reduce(function (a, i) { return a + i.price; }, 0); }
    function combo() {
      var d = idx && idx.discount;
      if (!d || d.is_combo_discount !== '1' || st.items.length < 2) return 0;
      return Number(d.amount) * (st.items.length - 1);
    }
    function total() { return Math.max(0, subtotal() - combo()); }
    function fetchJson(url) {
      return fetch(url).then(function (r) { if (!r.ok) throw new Error(url); return r.json(); });
    }
    function loadBrand(file) {
      if (brandCache[file]) return Promise.resolve(brandCache[file]);
      var bust = (idx && idx.version) ? ('?v=' + idx.version) : '';
      // Shopify-versioned asset_url (ververst gegarandeerd bij push); fallback op assetBase+?v
      var url = (window.MF_RP_ASSETS && window.MF_RP_ASSETS[file]) || (assetBase + file + bust);
      return fetchJson(url).then(function (d) { brandCache[file] = d; return d; });
    }

    /* ---------- stap 1: type / merk / model ---------- */
    function renderTypes() {
      st.step = 1; st.sub = 'types'; stepper();
      var h = '<h2 class="mf-rp__title">Selecteer <b>apparaat</b></h2><div class="mf-rp__grid mf-rp__grid--types">';
      idx.categories.forEach(function (c, i) {
        h += '<button type="button" class="mf-rp__card" data-cat="' + i + '">' +
          '<img loading="lazy" src="' + esc(imgUrl(c.img)) + '" alt="' + esc(c.name) + '">' +
          '<span class="mf-rp__card-name">' + esc(c.name) + '</span></button>';
      });
      body.innerHTML = h + '</div>';
      body.querySelectorAll('[data-cat]').forEach(function (el) {
        el.addEventListener('click', function () {
          var c = idx.categories[Number(el.getAttribute('data-cat'))];
          st.cat = c.name;
          var br = idx.brands[c.name];
          if (br && br.direct) { st.brand = ''; st.brandFile = br.file; renderModels(); }
          else renderBrands();
        });
      });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    function renderBrands() {
      st.sub = 'brands'; stepper();
      var brands = idx.brands[st.cat] || [];
      var h = '<h2 class="mf-rp__title"><button type="button" class="mf-rp__back" data-back>←</button> Selecteer het <b>merk</b></h2>' +
        '<div class="mf-rp__grid mf-rp__grid--brands">';
      brands.forEach(function (b, i) {
        h += '<button type="button" class="mf-rp__card" data-brand="' + i + '">' +
          '<img loading="lazy" src="' + esc(imgUrl(b.img)) + '" alt="' + esc(b.name) + '">' +
          '<span class="mf-rp__card-name">' + esc(b.name) + '</span></button>';
      });
      body.innerHTML = h + '</div>';
      body.querySelector('[data-back]').addEventListener('click', renderTypes);
      body.querySelectorAll('[data-brand]').forEach(function (el) {
        el.addEventListener('click', function () {
          var b = brands[Number(el.getAttribute('data-brand'))];
          st.brand = b.name; st.brandFile = b.file;
          renderModels();
        });
      });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    function renderModels() {
      st.sub = 'models'; stepper();
      body.innerHTML = '<div class="mf-rp__loading">Modellen laden…</div>';
      loadBrand(st.brandFile).then(function (data) {
        var h = '<h2 class="mf-rp__title"><button type="button" class="mf-rp__back" data-back>←</button> Welke <b>model</b> heb je?</h2>' +
          '<div style="display:flex;gap:14px;align-items:stretch;flex-wrap:wrap;margin-bottom:22px">' +
          '<div class="mf-rp__search" style="margin:0;flex:1 1 240px"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4-4"/></svg>' +
          '<input type="search" data-msearch placeholder="Zoek je model…" aria-label="Zoek je model"></div>' +
          '<div class="mf-rp__notfound" style="flex:1 1 300px;display:flex;align-items:center;padding:10px 16px;background:#f5f8fb;border:1px solid #e6ebf1;border-radius:12px;font-size:13px;color:#51647a;line-height:1.4">Staat je model er niet tussen? <b style="color:#0b2545">Geen probleem</b>, we repareren ook oudere modellen. <a href="https://wa.me/' + waNumber + '" target="_blank" rel="noopener" style="color:#2b7bc2;font-weight:600;white-space:nowrap">Neem contact met ons op</a>.</div>' +
          '</div>' +
          '<div class="mf-rp__grid mf-rp__grid--models" data-models></div>';
        body.innerHTML = h;
        var grid = body.querySelector('[data-models]');
        function draw(filter) {
          var f = (filter || '').toLowerCase();
          var hh = '';
          data.models.forEach(function (m, i) {
            if (f && m.name.toLowerCase().indexOf(f) === -1 && (m.codes || '').toLowerCase().indexOf(f) === -1) return;
            var codes = (m.codes || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean).slice(0, 4);
            hh += '<button type="button" class="mf-rp__card" data-model="' + i + '">' +
              (m.img ? '<img loading="lazy" src="' + esc(imgUrl(m.img)) + '" alt="' + esc(m.name) + '">' : '') +
              '<span class="mf-rp__card-name">' + esc(m.name) + '</span>' +
              (codes.length ? '<span class="mf-rp__codes">' + codes.map(function (c) { return '<span class="mf-rp__code">' + esc(c) + '</span>'; }).join('') + '</span>' : '') +
              '</button>';
          });
          grid.innerHTML = hh || '<p style="color:#8a94a3">Geen modellen gevonden.</p>';
          grid.querySelectorAll('[data-model]').forEach(function (el) {
            el.addEventListener('click', function () {
              st.model = data.models[Number(el.getAttribute('data-model'))];
              st.color = null; st.items = []; st.showAll = false;
              renderRepairs();
            });
          });
        }
        draw('');
        body.querySelector('[data-msearch]').addEventListener('input', function (e) { draw(e.target.value); });
        body.querySelector('[data-back]').addEventListener('click', function () {
          var br = idx.brands[st.cat];
          if (br && br.direct) renderTypes(); else renderBrands();
        });
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }).catch(function () { toast('Laden mislukt. Probeer het opnieuw.'); });
    }

    /* ---------- stap 2: reparaties ---------- */
    function renderRepairs() {
      st.step = 2; stepper();
      var m = st.model;
      var codes = (m.codes || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean).slice(0, 5);
      var h = '<div class="mf-rp__repairwrap"><div>' +
        '<div class="mf-rp__modelhead"><button type="button" class="mf-rp__back" data-back>←</button>' +
        (m.img ? '<img class="mf-rp__modelhead-img" src="' + esc(imgUrl(m.img)) + '" alt="">' : '') +
        '<div><h2 class="mf-rp__modelhead-name">' + esc((st.brand ? st.brand + ' ' : '') + m.name) + '</h2>' +
        (codes.length ? '<span class="mf-rp__codes">' + codes.map(function (c) { return '<span class="mf-rp__code">' + esc(c) + '</span>'; }).join('') + '</span> ' : '') +
        '<button type="button" class="mf-rp__modelhead-cat" data-back2>' + esc(st.cat) + '</button></div></div>';

      if (m.colors && m.colors.length) {
        h += '<div class="mf-rp__sectionlabel">Selecteer <b>kleur</b></div><div class="mf-rp__colors" data-colors>';
        m.colors.forEach(function (c, i) {
          h += '<button type="button" class="mf-rp__color" data-color="' + i + '">' +
            '<span class="mf-rp__color-square" style="background:' + esc(c.c) + '"></span>' +
            '<span class="mf-rp__color-name">' + esc(c.n) + '</span></button>';
        });
        h += '</div>';
      }

      h += '<div class="mf-rp__btwrow"><div class="mf-rp__sectionlabel" style="flex:1">Selecteer <b>reparatie</b></div>' +
        '<button type="button" class="mf-rp__btw" data-btw>' + (st.btw ? 'Incl. BTW' : 'Excl. BTW') + ' <span class="mf-rp__switch' + (st.btw ? ' is-on' : '') + '"></span></button></div>' +
        '<div class="mf-rp__repairs" data-repairs></div>';

      var hidden = m.repairs.length - (m.limited || 6);
      if (!st.showAll && hidden > 0) {
        h += '<button type="button" class="mf-rp__showall" data-showall>toon alle ' + m.repairs.length + ' reparaties ↓</button>';
      }
      h += '</div><aside>' + listHtml() + '</aside></div>';
      body.innerHTML = h;

      body.querySelector('[data-back]').addEventListener('click', renderModels);
      body.querySelector('[data-back2]').addEventListener('click', renderModels);
      var btwBtn = body.querySelector('[data-btw]');
      if (btwBtn) btwBtn.addEventListener('click', function () { st.btw = !st.btw; renderRepairs(); });
      var sa = body.querySelector('[data-showall]');
      if (sa) sa.addEventListener('click', function () { st.showAll = true; renderRepairs(); });
      body.querySelectorAll('[data-color]').forEach(function (el) {
        el.addEventListener('click', function () {
          st.color = m.colors[Number(el.getAttribute('data-color'))].n;
          body.querySelectorAll('[data-color]').forEach(function (x) { x.classList.remove('is-selected'); });
          el.classList.add('is-selected');
        });
      });
      drawRepairs();
      bindList();
      if (st.color) {
        body.querySelectorAll('[data-color]').forEach(function (el) {
          var c = m.colors[Number(el.getAttribute('data-color'))];
          if (c && c.n === st.color) el.classList.add('is-selected');
        });
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    function repairMinPrice(rep) {
      if (rep.opts && rep.opts.length) {
        return Math.min.apply(null, rep.opts.map(function (o) { return o.price; }));
      }
      return rep.price;
    }

    /* ---------- prijs op aanvraag (€0 = geen prijs bekend) ---------- */
    function isPOA(p) { return !(Number(p) > 0); }
    function hasPOA() { return st.items.some(function (it) { return isPOA(it.price); }); }
    // Weergave voor een reparatiekaart: {poa:true} of {poa:false, price, vanaf}
    function repairPriceView(rep) {
      if (rep.opts && rep.opts.length) {
        var priced = rep.opts.filter(function (o) { return Number(o.price) > 0; });
        if (!priced.length) return { poa: true };
        return { poa: false, price: Math.min.apply(null, priced.map(function (o) { return o.price; })), vanaf: true };
      }
      return isPOA(rep.price) ? { poa: true } : { poa: false, price: rep.price, vanaf: false };
    }

    function drawRepairs() {
      var m = st.model;
      var wrap = body.querySelector('[data-repairs]');
      if (!wrap) return;
      var list = st.showAll ? m.repairs : m.repairs.slice(0, m.limited || 6);
      var h = '';
      list.forEach(function (rep, i) {
        var sel = st.items.some(function (it) { return it.rid === rep.id; });
        var pv = repairPriceView(rep);
        var priceHtml;
        if (pv.poa) {
          priceHtml = '<span class="mf-rp__price mf-rp__price--poa">Prijs op<br>aanvraag</span>';
        } else {
          var f = fmt(pv.price);
          priceHtml = '<span class="mf-rp__price">' + (pv.vanaf && !sel ? '<span class="mf-rp__vanaf">vanaf</span>' : '') +
            '€' + f.e + '<small>' + f.c + '</small></span>';
        }
        h += '<div class="mf-rp__repair' + (sel ? ' is-selected' : '') + '" data-rep="' + i + '">' +
          '<button type="button" class="mf-rp__repair-card" data-repbtn="' + i + '">' +
          (rep.img ? '<img class="mf-rp__repair-icon" loading="lazy" src="' + esc(imgUrl(rep.img)) + '" alt="">' : '') +
          '<span class="mf-rp__repair-main"><span class="mf-rp__repair-name">' + esc(rep.name) +
          (rep.desc ? '<span class="mf-rp__info" title="' + esc(rep.desc) + '">i</span>' : '') + '</span>' +
          '<span class="mf-rp__repair-dur">' + esc(rep.dur || '60') + ' minuten</span></span>' +
          priceHtml +
          '</button><div data-optwrap></div></div>';
      });
      wrap.innerHTML = h;
      wrap.querySelectorAll('[data-repbtn]').forEach(function (el) {
        el.addEventListener('click', function () {
          var i = Number(el.getAttribute('data-repbtn'));
          var rep = list[i];
          var existing = -1;
          st.items.forEach(function (it, j) { if (it.rid === rep.id) existing = j; });
          if (existing >= 0) { st.items.splice(existing, 1); refresh(); return; }
          if (rep.opts && rep.opts.length) toggleOpts(el.closest('.mf-rp__repair'), rep);
          else { addItem(rep, null); refresh(); }
        });
      });
    }

    function toggleOpts(repEl, rep) {
      var wrap = repEl.querySelector('[data-optwrap]');
      var open = wrap.querySelector('.mf-rp__opts');
      body.querySelectorAll('.mf-rp__opts').forEach(function (x) { x.remove(); });
      if (open) return;
      var h = '<div class="mf-rp__opts">';
      rep.opts.forEach(function (o, i) {
        var priceHtml = isPOA(o.price)
          ? '<span class="mf-rp__opt-price mf-rp__price--poa">Prijs op aanvraag</span>'
          : (function () { var f = fmt(o.price); return '<span class="mf-rp__opt-price">€' + f.e + '<small>' + f.c + '</small></span>'; })();
        h += '<button type="button" class="mf-rp__opt" data-opt="' + i + '">' +
          '<span class="mf-rp__opt-main"><span class="mf-rp__opt-name">' + esc(o.name) + '</span>' +
          '<span class="mf-rp__opt-dur">' + esc(o.dur || rep.dur || '60') + ' MINUTEN</span>' +
          (o.desc ? '<span class="mf-rp__opt-desc">' + esc(o.desc) + '</span>' : '') + '</span>' +
          priceHtml + '</button>';
      });
      wrap.innerHTML = h + '</div>';
      wrap.querySelectorAll('[data-opt]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.stopPropagation();
          addItem(rep, rep.opts[Number(el.getAttribute('data-opt'))]);
          refresh();
        });
      });
    }

    function addItem(rep, opt) {
      st.items.push({
        rid: rep.id,
        rname: rep.name + (opt ? ' - ' + opt.name : ''),
        price: opt ? opt.price : rep.price,
        dur: (opt && opt.dur) || rep.dur || '60'
      });
    }

    function refresh() {
      drawRepairs();
      var aside = body.querySelector('aside');
      if (aside) { aside.innerHTML = listHtml(); bindList(); }
    }

    /* ---------- reparatie lijst ---------- */
    function listHtml() {
      var h = '<div class="mf-rp__list"><h3 class="mf-rp__list-title">Reparatie lijst</h3>' +
        '<p class="mf-rp__list-model">' + esc((st.brand ? st.brand + ' ' : '') + st.model.name) + '</p>' +
        '<div class="mf-rp__list-items">';
      st.items.forEach(function (it, i) {
        var priceStr = isPOA(it.price) ? 'op aanvraag' : (function () { var f = fmt(it.price); return f.e + ',' + f.c; })();
        h += '<div class="mf-rp__list-item"><button type="button" class="mf-rp__list-remove" data-rm="' + i + '" aria-label="Verwijderen">✕</button>' +
          '<span class="mf-rp__list-itemname">' + esc(it.rname) + '</span>' +
          '<span class="mf-rp__list-itemprice' + (isPOA(it.price) ? ' mf-rp__list-itemprice--poa' : '') + '">' + priceStr + '</span></div>';
      });
      h += '</div>';
      var sub = subtotal(), disc = combo(), poa = hasPOA();
      h += '<div class="mf-rp__list-row">Subtotaal <span class="val">' + (poa ? 'op aanvraag' : (st.items.length ? fmtFlat(sub).slice(1) : '-')) + '</span></div>';
      h += '<div class="mf-rp__list-row"><b>Combinatiekorting</b> <span class="val" style="color:var(--rp-blue)">' + (disc && !poa ? '- ' + fmtFlat(disc).slice(1) : '-') + '</span></div>';
      if (st.items.length === 1 && idx.discount && idx.discount.is_combo_discount === '1') {
        h += '<div class="mf-rp__combo-hint">🏷️ Voeg een extra reparatie toe en ontvang €' + esc(idx.discount.amount) + ' korting.</div>';
      }
      h += '<div class="mf-rp__total"><div class="mf-rp__total-label">Totaal <small>incl. btw (21%)</small></div>' +
        '<div class="mf-rp__total-amount">' + (poa ? '<span class="mf-rp__total-poa">Prijs op aanvraag</span>' : (st.items.length ? '€' + fmt(total()).e + '<small>' + fmt(total()).c + '</small>' : '-')) + '</div></div>';
      if (poa) {
        h += '<div class="mf-rp__poa-note">ℹ️ Voor je selectie geldt <b>prijs op aanvraag</b>. Vraag eerst een prijs aan — zodra wij je de prijs mailen, kun je een afspraak maken.</div>';
        h += '<button type="button" class="mf-rp__btn mf-rp__btn--primary" data-poa>Prijs aanvragen ▶<small>Je krijgt de prijs per e-mail</small></button>';
      } else {
        h += '<button type="button" class="mf-rp__btn mf-rp__btn--soft" data-offer>Stuur Offerte<small>Direct in je mailbox</small></button>';
        h += '<button type="button" class="mf-rp__btn mf-rp__btn--primary" data-next>Volgende Stap<small>Je betaalt pas na de reparatie</small></button>';
      }
      h += '<p class="mf-rp__poweredby">Mobielfabriq · De Raat 32, Houten</p></div>';
      return h;
    }

    function bindList() {
      body.querySelectorAll('[data-rm]').forEach(function (el) {
        el.addEventListener('click', function () { st.items.splice(Number(el.getAttribute('data-rm')), 1); refresh(); });
      });
      var offer = body.querySelector('[data-offer]');
      if (offer) offer.addEventListener('click', function () {
        if (!st.items.length) { toast('Kies eerst een reparatie.'); return; }
        renderOffer();
      });
      var next = body.querySelector('[data-next]');
      if (next) next.addEventListener('click', function () {
        var needColor = st.model.colors && st.model.colors.length > 0;
        if ((needColor && !st.color) || !st.items.length) {
          toast('Kies alsjeblieft eerst de kleur en reparatie voordat je verder gaat.');
          return;
        }
        if (hasPOA()) { renderOffer(); return; }   // prijs op aanvraag → geen afspraak, eerst prijs aanvragen
        renderFinal();
      });
      var poaBtn = body.querySelector('[data-poa]');
      if (poaBtn) poaBtn.addEventListener('click', function () {
        var needColor = st.model.colors && st.model.colors.length > 0;
        if ((needColor && !st.color) || !st.items.length) {
          toast('Kies alsjeblieft eerst de kleur en reparatie voordat je verder gaat.');
          return;
        }
        renderOffer();
      });
    }

    /* ---------- afspraakgegevens (voor samenvatting + e-mail) ---------- */
    function modelFullName() { return (st.brand ? st.brand + ' ' : '') + st.model.name; }
    function serviceLabel() { return st.service === 'verstuur' ? 'Verstuur apparaat' : 'Kom langs in onze winkel'; }
    function repairLines() {
      return st.items.map(function (it) {
        return it.rname + ' — ' + fmtFlat(it.price) + (it.dur ? ' (' + it.dur + ' min)' : '');
      });
    }

    /* ---------- openingstijden + datum/tijd-helpers (1-op-1 RepairPlugin) ---------- */
    // index: 0=zondag … 6=zaterdag. [open, sluit] in uren (decimaal). null = gesloten.
    var OPENING = { 0: null, 1: [9.5, 18], 2: [9.5, 18], 3: [9.5, 18], 4: [9.5, 18], 5: [9.5, 18], 6: [9.5, 17] };
    var DAY_SHORT = ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'];
    var DAY_FULL = ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'];
    var MONTHS = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];
    function pad2(n) { return (n < 10 ? '0' : '') + n; }
    function ymd(d) { return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate()); }
    function startOfDay(d) { return new Date(d.getFullYear(), d.getMonth(), d.getDate()); }
    function addDays(d, n) { var x = startOfDay(d); x.setDate(x.getDate() + n); return x; }
    function fromYmd(k) { var p = k.split('-'); return new Date(+p[0], +p[1] - 1, +p[2]); }
    function slotsFor(key) {
      var d = fromYmd(key), oh = OPENING[d.getDay()];
      if (!oh) return [];
      var now = new Date(), isToday = key === ymd(now), nowMin = now.getHours() * 60 + now.getMinutes();
      var out = [];
      for (var t = oh[0]; t <= oh[1] - 0.5 + 1e-9; t += 0.5) {
        var hh = Math.floor(t + 1e-9), mm = Math.round((t - hh) * 60);
        if (isToday && (hh * 60 + mm) <= nowMin) continue; // verstreken tijden vandaag overslaan
        out.push(pad2(hh) + ':' + pad2(mm));
      }
      return out;
    }
    function apptDateText() { if (!st.date) return ''; var d = fromYmd(st.date); return DAY_FULL[d.getDay()] + ' ' + d.getDate() + '-' + pad2(d.getMonth() + 1) + '-' + d.getFullYear(); }
    function apptFull() { return st.service === 'verstuur' ? 'Opsturen (reparatie binnen 24 uur)' : (st.date && st.time ? apptDateText() + ' om ' + st.time : ''); }

    /* ---------- stap 3: afronden afspraak — alles inline (RepairPlugin-stijl) ---------- */
    function renderFinal() {
      st.step = 3; stepper();
      if (!st.service) st.service = 'winkel';
      if (st.particulier === undefined) st.particulier = true;
      if (st.dayOffset === undefined) st.dayOffset = 0;
      if (!st.date) st.date = ymd(new Date());
      var m = st.model, modelFull = modelFullName();

      var h = '<h2 class="mf-rp__title"><button type="button" class="mf-rp__back" data-back>←</button> Afronden <b>afspraak</b></h2>' +
        '<div class="mf-rp__final"><div>' +
        '<p style="color:#5a6472;margin:0 0 14px">Selecteer servicemethode</p>' +

        '<div class="mf-rp__service' + (st.service === 'winkel' ? ' is-selected' : '') + '" data-svc="winkel">' +
        '<button type="button" class="mf-rp__service-head" style="width:100%">' +
        '<span style="font-size:1.5rem">🏪</span>' +
        '<span class="mf-rp__service-name"><b>Kom langs in onze winkel</b><span class="mf-rp__service-badge">GRATIS</span>' +
        '<span class="mf-rp__service-sub">Klaar terwijl je wacht</span></span>' +
        '<span class="mf-rp__check"></span></button>' +
        '<div class="mf-rp__svc-body" data-detail="winkel"' + (st.service === 'winkel' ? '' : ' hidden') + '>' +
        '<div class="mf-rp__sectionlabel">Selecteer <b>locatie</b></div>' +
        '<div class="mf-rp__loc is-selected"><b>Mobielfabriq</b><br>De Raat 32<br>3995 EP Houten</div>' +
        '<div class="mf-rp__sectionlabel">Selecteer <b>datum</b></div>' +
        '<div class="mf-rp__cal"><button type="button" class="mf-rp__cal-nav" data-week="-1" aria-label="Vorige">‹</button>' +
        '<div class="mf-rp__days" data-rp-dates></div>' +
        '<button type="button" class="mf-rp__cal-nav" data-week="1" aria-label="Volgende">›</button></div>' +
        '<div class="mf-rp__sectionlabel">Selecteer <b>tijd</b></div>' +
        '<div class="mf-rp__times" data-rp-times></div>' +
        '</div></div>' +

        '<div class="mf-rp__service' + (st.service === 'verstuur' ? ' is-selected' : '') + '" data-svc="verstuur">' +
        '<button type="button" class="mf-rp__service-head" style="width:100%">' +
        '<span style="font-size:1.5rem">📦</span>' +
        '<span class="mf-rp__service-name"><b>Verstuur apparaat</b><span class="mf-rp__service-badge">GRATIS</span>' +
        '<span class="mf-rp__service-sub">Reparatie binnen 24 uur</span></span>' +
        '<span class="mf-rp__check"></span></button>' +
        '<div class="mf-rp__svc-body" data-detail="verstuur"' + (st.service === 'verstuur' ? '' : ' hidden') + '>' +
        '<p style="color:#5a6472;font-size:.92rem;line-height:1.55;margin:4px 2px 0">Verstuur je toestel naar <b>Mobielfabriq, De Raat 32, 3995 EP Houten</b>. Vul hiernaast je gegevens in — na je aanvraag mailen we de verzendinstructies.</p>' +
        '</div></div>' +

        '</div><div>' +
        '<div class="mf-rp__modelhead">' +
        (m.img ? '<img class="mf-rp__modelhead-img" src="' + esc(imgUrl(m.img)) + '" alt="">' : '') +
        '<div><h3 class="mf-rp__modelhead-name" style="font-size:1.35rem;margin:0">' + esc(modelFull) + '</h3>' +
        '<button type="button" class="mf-rp__modelhead-cat" data-back2>reparatie aanpassen</button></div></div>' +

        '<div class="mf-rp__sum"><div class="mf-rp__sum-row"><span>' + esc(modelFull + (st.color ? ' · ' + st.color : '')) + '</span>' +
        '<span class="mf-rp__sum-svc" data-sum-svc>' + esc(serviceLabel()) + '</span></div>' +
        st.items.map(function (it) {
          return '<div class="mf-rp__sum-row"><span>' + esc(it.rname) + (it.dur ? ' <small style="color:#8a94a3">· ' + esc(it.dur) + ' min</small>' : '') + '</span><span>' + fmtFlat(it.price) + '</span></div>';
        }).join('') +
        (combo() ? '<div class="mf-rp__sum-row"><span>Combinatiekorting</span><span>- ' + fmtFlat(combo()) + '</span></div>' : '') +
        '<div class="mf-rp__sum-row mf-rp__sum-appt" data-rp-appt' + (apptFull() ? '' : ' hidden') + '><span>Afspraak op</span><b>' + esc(apptFull()) + '</b></div>' +
        '<div class="mf-rp__sum-total"><div class="t">Totaal <small>incl. 21% BTW</small></div>' +
        '<div class="amount">' + fmtFlat(total()) + '</div></div></div>' +

        '<div class="mf-rp__klanttype">' +
        '<button type="button" class="mf-rp__radio' + (st.particulier ? ' is-on' : '') + '" data-klant="part"><span></span>Particulier</button>' +
        '<button type="button" class="mf-rp__radio' + (!st.particulier ? ' is-on' : '') + '" data-klant="zak"><span></span>Zakelijk</button>' +
        '</div>' +

        '<div class="mf-rp__fields" data-appt-form>' +
        '<label class="mf-rp__field"><span>Voornaam *</span><input type="text" name="vn" required autocomplete="given-name"></label>' +
        '<label class="mf-rp__field"><span>Achternaam *</span><input type="text" name="an" required autocomplete="family-name"></label>' +
        '<label class="mf-rp__field"><span>Telefoonnummer *</span><input type="tel" name="tel" required autocomplete="tel" inputmode="tel"></label>' +
        '<label class="mf-rp__field"><span>E-mailadres *</span><input type="email" name="email" required autocomplete="email" inputmode="email"></label>' +
        '<label class="mf-rp__field mf-rp__field--full"><span>Notities</span><textarea name="note" rows="3" placeholder="Bijv. schade-omschrijving of een opmerking"></textarea></label>' +
        '</div>' +

        '<button type="button" class="mf-rp__btn mf-rp__btn--primary" data-confirm>Bevestig afspraak ▶<small>Je betaalt pas na de reparatie</small></button>' +
        '<a class="mf-rp__btn mf-rp__btn--soft" style="text-decoration:none" target="_blank" rel="noopener" href="https://wa.me/' + esc(waNumber) +
        '?text=' + encodeURIComponent('Hallo Mobielfabriq, ik wil graag een afspraak voor: ' + modelFull + (st.color ? ' (' + st.color + ')' : '') + ' — ' + st.items.map(function (i) { return i.rname; }).join(', ')) +
        '">Liever via WhatsApp?<small>Reactie binnen 30 minuten</small></a>' +
        '</div></div>' +

        '<div class="mf-rp__usps">' +
        '<div class="mf-rp__usp"><div class="mf-rp__usp-icon">✓</div><h3>3 Maanden garantie</h3><p>3 maanden garantie op uw reparatie op het desbetreffende onderdeel: uw zekerheid dat alles tot in de puntjes is verzorgd!</p></div>' +
        '<div class="mf-rp__usp"><div class="mf-rp__usp-icon">✓</div><h3>Originele onderdelen</h3><p>Met originele onderdelen haalt u het beste uit uw toestel. Ze zijn ontworpen voor topprestaties en zorgen ervoor dat uw apparaat langer meegaat.</p></div>' +
        '<div class="mf-rp__usp"><div class="mf-rp__usp-icon">✓</div><h3>12 jaar+ ervaring</h3><p>Met jarenlange expertise staan wij garant voor kwaliteit en service waar u op kunt vertrouwen.</p></div>' +
        '</div>';

      body.innerHTML = h;
      body.querySelector('[data-back]').addEventListener('click', renderRepairs);
      body.querySelector('[data-back2]').addEventListener('click', renderRepairs);

      function updateApptLine() {
        var row = body.querySelector('[data-rp-appt]');
        if (!row) return;
        var txt = apptFull();
        row.hidden = !txt;
        if (txt) row.querySelector('b').textContent = txt;
        var lbl = body.querySelector('[data-sum-svc]');
        if (lbl) lbl.textContent = serviceLabel();
      }

      function paintDates() {
        var wrap = body.querySelector('[data-rp-dates]');
        if (!wrap) return;
        var today = new Date(), hh = '';
        for (var i = 0; i < 8; i++) {
          var d = addDays(today, st.dayOffset + i), key = ymd(d), closed = !OPENING[d.getDay()];
          hh += '<button type="button" class="mf-rp__day' + (key === st.date ? ' is-active' : '') + (closed ? ' is-closed' : '') + '"' +
            (closed ? ' disabled' : ' data-date="' + key + '"') + '>' +
            '<span class="d">' + DAY_SHORT[d.getDay()] + '</span><span class="n">' + d.getDate() + '</span></button>';
        }
        wrap.innerHTML = hh;
        wrap.querySelectorAll('[data-date]').forEach(function (b) {
          b.addEventListener('click', function () { st.date = b.getAttribute('data-date'); st.time = null; paintDates(); paintTimes(); updateApptLine(); });
        });
        var prev = body.querySelector('[data-week="-1"]');
        if (prev) prev.disabled = st.dayOffset <= 0;
      }

      function paintTimes() {
        var wrap = body.querySelector('[data-rp-times]');
        if (!wrap) return;
        var slots = slotsFor(st.date);
        if (!slots.length) {
          var d = fromYmd(st.date);
          wrap.innerHTML = '<div class="mf-rp__times-empty">' + (OPENING[d.getDay()] ? 'Geen tijden meer beschikbaar op deze dag — kies een andere dag.' : 'Op deze dag zijn we gesloten — kies een andere dag.') + '</div>';
          return;
        }
        wrap.innerHTML = slots.map(function (s) {
          return '<button type="button" class="mf-rp__slot' + (s === st.time ? ' is-active' : '') + '" data-time="' + s + '">' + s + '</button>';
        }).join('');
        wrap.querySelectorAll('[data-time]').forEach(function (b) {
          b.addEventListener('click', function () { st.time = b.getAttribute('data-time'); paintTimes(); updateApptLine(); });
        });
      }

      // servicemethode wisselen
      body.querySelectorAll('[data-svc]').forEach(function (el) {
        el.querySelector('.mf-rp__service-head').addEventListener('click', function () {
          st.service = el.getAttribute('data-svc');
          body.querySelectorAll('[data-svc]').forEach(function (x) { x.classList.toggle('is-selected', x === el); });
          body.querySelectorAll('[data-detail]').forEach(function (det) { det.hidden = det.getAttribute('data-detail') !== st.service; });
          updateApptLine();
        });
      });
      // week-navigatie
      body.querySelectorAll('[data-week]').forEach(function (b) {
        b.addEventListener('click', function () {
          st.dayOffset = Math.max(0, st.dayOffset + Number(b.getAttribute('data-week')) * 8);
          paintDates();
        });
      });
      // klanttype
      body.querySelectorAll('[data-klant]').forEach(function (b) {
        b.addEventListener('click', function () {
          st.particulier = b.getAttribute('data-klant') === 'part';
          body.querySelectorAll('[data-klant]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        });
      });
      body.querySelector('[data-confirm]').addEventListener('click', function () { submitAppointment(this); });

      paintDates();
      paintTimes();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    function submitAppointment(btn) {
      var form = body.querySelector('[data-appt-form]');
      var fld = function (n) { return form.querySelector('[name="' + n + '"]'); };
      var vn = fld('vn').value.trim(), an = fld('an').value.trim();
      var tel = fld('tel').value.trim(), email = fld('email').value.trim();
      var note = fld('note').value.trim();

      var bad = null;
      if (!vn) bad = fld('vn'); else if (!an) bad = fld('an');
      else if (!tel || tel.replace(/[^0-9]/g, '').length < 8) bad = fld('tel');
      else if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) bad = fld('email');
      if (bad) {
        toast('Vul alsjeblieft je naam, telefoonnummer en een geldig e-mailadres in.');
        bad.focus(); bad.classList.add('mf-rp__field--err');
        setTimeout(function () { bad.classList.remove('mf-rp__field--err'); }, 2500);
        return;
      }
      if (st.service === 'winkel' && (!st.date || !st.time)) {
        toast('Kies alsjeblieft eerst een datum en tijd voor je afspraak.');
        return;
      }

      var modelFull = modelFullName();
      var toestel = modelFull + (st.color ? ' (' + st.color + ')' : '');
      var naam = (vn + ' ' + an).trim();
      var afspraak = apptFull();
      var ctx = {
        naam: naam, tel: tel, email: email, note: note,
        modelFull: modelFull, color: st.color,
        items: st.items.map(function (it) { return { rname: it.rname, dur: it.dur, price: fmtFlat(it.price) }; }),
        totalStr: fmtFlat(total()), serviceLabel: serviceLabel(), afspraak: afspraak
      };

      var waMsg = ['Nieuwe reparatie-afspraak via de website', '', 'Toestel: ' + toestel,
        'Reparatie(s): ' + repairLines().join(' + '), 'Totaal (incl. 21% btw): ' + ctx.totalStr,
        'Servicemethode: ' + ctx.serviceLabel, 'Afspraak: ' + (afspraak || '-'),
        'Klanttype: ' + (st.particulier ? 'Particulier' : 'Zakelijk'), '',
        'Naam: ' + naam, 'Telefoon: ' + tel, 'E-mail: ' + email, 'Opmerking: ' + (note || '-')].join('\n');
      function openWhatsApp() { try { window.open('https://wa.me/' + waNumber + '?text=' + encodeURIComponent(waMsg), '_blank'); } catch (e) {} }
      function succeed() { renderConfirmation(ctx); }

      // PRIMAIR: Google Apps Script webhook -> agenda-afspraak + opgemaakte e-mail (klant + winkel).
      if (apptWebhook) {
        btn.disabled = true; btn.style.opacity = '.6';
        var durMin = st.items.reduce(function (a, it) { return a + (parseInt(it.dur, 10) || 0); }, 0) || 60;
        var hook = {
          naam: naam, voornaam: vn, email: email, tel: tel,
          klanttype: st.particulier ? 'Particulier' : 'Zakelijk',
          toestel: toestel, reparatie: repairLines().join(' + '),
          items: st.items.map(function (it) { return { naam: it.rname + (it.dur ? ' · ' + it.dur + ' min' : ''), prijs: fmtFlat(it.price) }; }),
          totaal: ctx.totalStr, servicemethode: ctx.serviceLabel,
          datum: st.service === 'winkel' ? st.date : '', tijd: st.service === 'winkel' ? st.time : '',
          durMin: durMin, opmerking: note || '-'
        };
        // no-cors: Apps Script verwerkt de POST; respons is opaque, dus toon altijd de bevestiging.
        fetch(apptWebhook, {
          method: 'POST', mode: 'no-cors',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify(hook)
        }).then(succeed, succeed);
        // Vangnet: stuur óók een backup-notificatie naar de winkel via web3forms — mislukt de webhook stil, dan mis je de boeking niet.
        if (formKey) {
          try {
            fetch('https://api.web3forms.com/submit', {
              method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({
                access_key: formKey,
                subject: '📅 Reparatie-afspraak (backup): ' + toestel + (afspraak ? ' — ' + afspraak : ''),
                from_name: 'Mobielfabriq afspraak-backup', email: email, replyto: email,
                'Naam': naam, 'Telefoonnummer': tel, 'Klanttype': st.particulier ? 'Particulier' : 'Zakelijk',
                'Toestel': toestel, 'Reparatie': repairLines().join(' + '), 'Totaal (incl. btw)': ctx.totalStr,
                'Servicemethode': ctx.serviceLabel, 'Afspraak datum/tijd': afspraak || '-', 'Opmerking': note || '-'
              })
            });
          } catch (e) {}
        }
        return;
      }

      if (formKey) {
        btn.disabled = true; btn.style.opacity = '.6';
        var payload = {
          access_key: formKey,
          subject: 'Nieuwe reparatie-afspraak: ' + toestel + (afspraak ? ' — ' + afspraak : ''),
          from_name: 'Mobielfabriq reparatie-aanvraag',
          email: email, replyto: email,
          'Naam': naam, 'Telefoonnummer': tel, 'Klanttype': st.particulier ? 'Particulier' : 'Zakelijk',
          'Toestel': toestel, 'Reparatie': repairLines().join(' + '), 'Totaal (incl. btw)': ctx.totalStr,
          'Servicemethode': ctx.serviceLabel, 'Afspraak datum/tijd': afspraak || '-', 'Opmerking': note || '-'
        };
        fetch('https://api.web3forms.com/submit', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        }).then(function (r) { return r.json(); }).then(function (j) {
          if (j && j.success) succeed(); else { openWhatsApp(); succeed(); }
        }).catch(function () { openWhatsApp(); succeed(); });
        return;
      }
      openWhatsApp();
      succeed();
    }

    /* ---------- offerte: gegevens invullen -> opgemaakte offerte per e-mail ---------- */
    function offerServiceCard(key, icon, name, sub) {
      return '<div class="mf-rp__service' + (st.service === key ? ' is-selected' : '') + '" data-osvc="' + key + '">' +
        '<button type="button" class="mf-rp__service-head" style="width:100%">' +
        '<span style="font-size:1.5rem">' + icon + '</span>' +
        '<span class="mf-rp__service-name"><b>' + name + '</b><span class="mf-rp__service-badge">GRATIS</span>' +
        '<span class="mf-rp__service-sub">' + sub + '</span></span>' +
        '<span class="mf-rp__check"></span></button></div>';
    }
    function renderOffer() {
      if (!st.service) st.service = 'winkel';
      var m = st.model, modelFull = modelFullName(), poa = hasPOA();
      var h = '<h2 class="mf-rp__title"><button type="button" class="mf-rp__back" data-back-offer>←</button> ' + (poa ? 'Vraag een <b>prijs aan</b>' : 'Ontvang een offerte <b>per e-mail</b>') + '</h2>' +
        '<div class="mf-rp__final"><div>' +
        '<p style="color:#5a6472;margin:0 0 14px">' + (poa ? 'Vul je gegevens in — we sturen je zo snel mogelijk de prijs. Daarna kun je een afspraak maken.' : 'Vul je gegevens in — je ontvangt de prijsopgave direct in je mailbox.') + '</p>' +
        '<p style="color:#2c3440;font-weight:700;margin:0 0 10px">Selecteer servicemethode</p>' +
        offerServiceCard('winkel', '🏪', 'Kom langs in onze winkel', 'Klaar terwijl je wacht') +
        offerServiceCard('verstuur', '📦', 'Verstuur apparaat', 'Reparatie binnen 24 uur') +
        '</div><div>' +
        '<div class="mf-rp__modelhead">' +
        (m.img ? '<img class="mf-rp__modelhead-img" src="' + esc(imgUrl(m.img)) + '" alt="">' : '') +
        '<div><h3 class="mf-rp__modelhead-name" style="font-size:1.35rem;margin:0">' + esc(modelFull) + '</h3>' +
        '<button type="button" class="mf-rp__modelhead-cat" data-back-offer>reparatie aanpassen</button></div></div>' +
        '<div class="mf-rp__sum">' +
        '<div class="mf-rp__sum-row"><span>' + esc(modelFull + (st.color ? ' · ' + st.color : '')) + '</span><span>' + esc(serviceLabel()) + '</span></div>' +
        st.items.map(function (it) { return '<div class="mf-rp__sum-row"><span>' + esc(it.rname) + '</span><span>' + (isPOA(it.price) ? 'op aanvraag' : fmtFlat(it.price)) + '</span></div>'; }).join('') +
        (combo() && !poa ? '<div class="mf-rp__sum-row"><span>Combinatiekorting</span><span>- ' + fmtFlat(combo()) + '</span></div>' : '') +
        '<div class="mf-rp__sum-total"><div class="t">Totaal <small>incl. 21% BTW</small></div><div class="amount">' + (poa ? 'Op aanvraag' : fmtFlat(total())) + '</div></div></div>' +
        '<div class="mf-rp__fields" data-offer-form>' +
        '<label class="mf-rp__field"><span>Voornaam *</span><input type="text" name="vn" required autocomplete="given-name"></label>' +
        '<label class="mf-rp__field"><span>Achternaam *</span><input type="text" name="an" required autocomplete="family-name"></label>' +
        '<label class="mf-rp__field"><span>Straatnaam *</span><input type="text" name="straat" required autocomplete="address-line1"></label>' +
        '<label class="mf-rp__field"><span>Huisnummer *</span><input type="text" name="huisnr" required></label>' +
        '<label class="mf-rp__field"><span>Postcode *</span><input type="text" name="postcode" required autocomplete="postal-code"></label>' +
        '<label class="mf-rp__field"><span>Stad *</span><input type="text" name="stad" required autocomplete="address-level2"></label>' +
        '<label class="mf-rp__field"><span>Land *</span><input type="text" name="land" value="Nederland" required autocomplete="country-name"></label>' +
        '<label class="mf-rp__field"><span>Telefoonnummer *</span><input type="tel" name="tel" required autocomplete="tel" inputmode="tel"></label>' +
        '<label class="mf-rp__field mf-rp__field--full"><span>E-mailadres *</span><input type="email" name="email" required autocomplete="email" inputmode="email"></label>' +
        '<label class="mf-rp__field mf-rp__field--full"><span>IMEI-nummer <small style="color:#8a94a3">(optioneel)</small></span><input type="text" name="imei" inputmode="numeric"></label>' +
        '</div>' +
        '<button type="button" class="mf-rp__btn mf-rp__btn--primary" data-send-offer>' + (poa ? 'Verstuur prijsaanvraag ▶' : 'Verstuur offerte ▶') + '<small>' + (poa ? 'Je krijgt de prijs per e-mail' : 'Direct in je mailbox') + '</small></button>' +
        '<p class="mf-rp__poweredby">' + (poa ? 'Vrijblijvend · je krijgt de prijs per e-mail · daarna afspraak maken' : 'Vrijblijvend · geldig 14 dagen · je betaalt pas na de reparatie') + '</p>' +
        '</div></div>';
      body.innerHTML = h;
      body.querySelectorAll('[data-back-offer]').forEach(function (el) { el.addEventListener('click', renderRepairs); });
      body.querySelectorAll('[data-osvc]').forEach(function (el) { el.addEventListener('click', function () {
        var _form = body.querySelector('[data-offer-form]'); var _saved = {};
        if (_form) _form.querySelectorAll('[name]').forEach(function (i) { _saved[i.name] = i.value; });
        st.service = el.getAttribute('data-osvc'); renderOffer();
        var _f2 = body.querySelector('[data-offer-form]');
        if (_f2) Object.keys(_saved).forEach(function (n) { var i = _f2.querySelector('[name="' + n + '"]'); if (i && _saved[n]) i.value = _saved[n]; });
      }); });
      body.querySelector('[data-send-offer]').addEventListener('click', function () { submitOffer(this); });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    function submitOffer(btn) {
      var form = body.querySelector('[data-offer-form]');
      var fld = function (n) { var el = form.querySelector('[name="' + n + '"]'); return el ? el.value.trim() : ''; };
      var v = { vn: fld('vn'), an: fld('an'), straat: fld('straat'), huisnr: fld('huisnr'), postcode: fld('postcode'), stad: fld('stad'), land: fld('land'), tel: fld('tel'), email: fld('email'), imei: fld('imei') };
      var order = ['vn', 'an', 'straat', 'huisnr', 'postcode', 'stad', 'land', 'tel', 'email'];
      var bad = null;
      for (var i = 0; i < order.length; i++) { if (!v[order[i]]) { bad = order[i]; break; } }
      if (!bad && v.tel.replace(/[^0-9]/g, '').length < 8) bad = 'tel';
      if (!bad && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v.email)) bad = 'email';
      if (bad) {
        var be = form.querySelector('[name="' + bad + '"]');
        toast('Vul alsjeblieft alle verplichte velden correct in.');
        be.focus(); be.classList.add('mf-rp__field--err');
        setTimeout(function () { be.classList.remove('mf-rp__field--err'); }, 2500);
        return;
      }
      var modelFull = modelFullName();
      var toestel = modelFull + (st.color ? ' (' + st.color + ')' : '');
      var naam = (v.vn + ' ' + v.an).trim();
      var poa = hasPOA();
      var ctx = {
        naam: naam, email: v.email, tel: v.tel, toestel: toestel, modelFull: modelFull, color: st.color, poa: poa,
        items: st.items.map(function (it) { return { rname: it.rname, price: isPOA(it.price) ? 'op aanvraag' : fmtFlat(it.price) }; }),
        totalStr: poa ? 'Op aanvraag' : fmtFlat(total()), serviceLabel: serviceLabel()
      };
      var hook = {
        type: 'offerte',
        naam: naam, voornaam: v.vn, achternaam: v.an, email: v.email, tel: v.tel, imei: v.imei,
        straat: v.straat, huisnr: v.huisnr, postcode: v.postcode, stad: v.stad, land: v.land,
        toestel: toestel, toestelImg: (m_imgAbs()), servicemethode: serviceLabel(),
        items: st.items.map(function (it) { return { naam: it.rname + (it.dur ? ' · ' + it.dur + ' min' : ''), prijs: fmtFlat(it.price), prijsNum: it.price }; }),
        totaal: ctx.totalStr, totaalNum: total(),
        vervolgUrl: location.origin + '/pages/reparatie?cat=' + encodeURIComponent(st.cat || 'Smartphone') + (st.brand ? '&merk=' + encodeURIComponent(st.brand) : '') + '&model=' + encodeURIComponent(st.model.name)
      };
      function done() { renderOfferDone(ctx); }
      if (poa) {
        // Prijsaanvraag → geen offerte-PDF; een duidelijke melding naar de winkel zodat jij eerst de prijs invoert.
        if (formKey) {
          btn.disabled = true; btn.style.opacity = '.6';
          var poaPayload = {
            access_key: formKey, subject: '🔔 Prijsaanvraag aangemeld: ' + toestel, from_name: 'Mobielfabriq prijsaanvraag', email: v.email, replyto: v.email,
            'Let op': 'PRIJSAANVRAAG — voer eerst de prijs in, daarna kan de klant een afspraak maken.',
            'Naam': naam, 'Adres': v.straat + ' ' + v.huisnr + ', ' + v.postcode + ' ' + v.stad + ', ' + v.land,
            'Telefoon': v.tel, 'IMEI': v.imei || '-', 'Toestel': toestel, 'Servicemethode': serviceLabel(),
            'Gevraagde reparatie(s)': st.items.map(function (it) { return it.rname; }).join(' + ')
          };
          fetch('https://api.web3forms.com/submit', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(poaPayload) })
            .then(function (r) { return r.json(); }).then(done, done).catch(done);
          return;
        }
        if (apptWebhook) {
          btn.disabled = true; btn.style.opacity = '.6';
          fetch(apptWebhook, { method: 'POST', mode: 'no-cors', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify({ type: 'prijsaanvraag', naam: naam, voornaam: v.vn, achternaam: v.an, email: v.email, tel: v.tel, imei: v.imei, straat: v.straat, huisnr: v.huisnr, postcode: v.postcode, stad: v.stad, land: v.land, toestel: toestel, servicemethode: serviceLabel(), items: st.items.map(function (it) { return { naam: it.rname }; }) }) }).then(done, done);
          return;
        }
        done();
        return;
      }
      if (apptWebhook) {
        btn.disabled = true; btn.style.opacity = '.6';
        var sendHook = function () { fetch(apptWebhook, { method: 'POST', mode: 'no-cors', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify(hook) }).then(done, done); };
        // Genereer de offerte-PDF (met logo) in de browser; valt stil terug op verzenden zonder bijlage.
        if (typeof window.MF_makeOfferPdf === 'function') {
          window.MF_makeOfferPdf(hook).then(function (res) {
            if (res && res.b64) { hook.pdfBase64 = res.b64; hook.pdfName = 'Offerte-' + res.nr + '.pdf'; hook.nr = res.nr; }
            sendHook();
          }, sendHook);
        } else { sendHook(); }
        return;
      }
      if (formKey) {
        btn.disabled = true; btn.style.opacity = '.6';
        var payload = {
          access_key: formKey, subject: 'Offerte-aanvraag: ' + toestel, from_name: 'Mobielfabriq offerte-aanvraag', email: v.email, replyto: v.email,
          'Naam': naam, 'Adres': v.straat + ' ' + v.huisnr + ', ' + v.postcode + ' ' + v.stad + ', ' + v.land,
          'Telefoon': v.tel, 'IMEI': v.imei || '-', 'Toestel': toestel, 'Servicemethode': serviceLabel(),
          'Reparatie': repairLines().join(' + '), 'Totaal (incl. btw)': ctx.totalStr
        };
        fetch('https://api.web3forms.com/submit', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload) })
          .then(function (r) { return r.json(); }).then(done, done).catch(done);
        return;
      }
      done();
    }
    function m_imgAbs() {
      try { var u = imgUrl(st.model.img || ''); if (u && u.indexOf('//') === 0) u = location.protocol + u; return u || ''; } catch (e) { return ''; }
    }
    function renderOfferDone(ctx) {
      root.querySelectorAll('[data-step-dot]').forEach(function (el) { el.classList.add('is-done'); });
      var poa = ctx.poa;
      var h = '<div class="mf-rp__confirm">' +
        '<div class="mf-rp__confirm-check">✓</div>' +
        '<h2 class="mf-rp__confirm-title">Bedankt' + (ctx.naam ? ', ' + esc(ctx.naam.split(' ')[0]) : '') + '! ' + (poa ? 'Je prijsaanvraag is ontvangen.' : 'Je offerte is onderweg.') + '</h2>' +
        '<p class="mf-rp__confirm-text">' + (poa
          ? 'We hebben je aanvraag voor <b>' + esc(ctx.toestel) + '</b> ontvangen. Je krijgt zo snel mogelijk de prijs per e-mail (<b>' + esc(ctx.email) + '</b>). Zodra je de prijs hebt, kun je direct een afspraak maken — check ook even je spam.'
          : 'We hebben je aanvraag ontvangen. Je prijsopgave voor <b>' + esc(ctx.toestel) + '</b> komt eraan in je mailbox (<b>' + esc(ctx.email) + '</b>) — check ook even je spam.') + '</p>' +
        '<div class="mf-rp__confirm-card">' +
        '<div class="mf-rp__confirm-row"><span>Toestel</span><b>' + esc(ctx.modelFull + (ctx.color ? ' · ' + ctx.color : '')) + '</b></div>' +
        ctx.items.map(function (it) { return '<div class="mf-rp__confirm-row"><span>Reparatie</span><b>' + esc(it.rname) + '</b></div>'; }).join('') +
        '<div class="mf-rp__confirm-row"><span>Servicemethode</span><b>' + esc(ctx.serviceLabel) + '</b></div>' +
        '<div class="mf-rp__confirm-row mf-rp__confirm-row--total"><span>' + (poa ? 'Prijs' : 'Totaal incl. btw') + '</span><b>' + esc(ctx.totalStr) + '</b></div>' +
        '</div>' +
        '<p class="mf-rp__confirm-coffee">Geen mail ontvangen? Bel ons op 030 737 10 60 of stuur een WhatsApp.</p>' +
        '<div class="mf-rp__confirm-btns">' +
        '<a class="mf-rp__btn mf-rp__btn--primary" style="text-decoration:none" href="/pages/reparatie">Nieuwe aanvraag</a>' +
        '</div></div>';
      body.innerHTML = h;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    /* ---------- bevestiging (RepairPlugin-stijl) ---------- */
    function renderConfirmation(ctx) {
      root.querySelectorAll('[data-step-dot]').forEach(function (el) { el.classList.remove('is-active'); el.classList.add('is-done'); });
      var maps = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent('Mobielfabriq De Raat 32 3995 EP Houten');
      var waText = encodeURIComponent('Hallo Mobielfabriq, ik heb zojuist een afspraak aangevraagd voor: ' + ctx.modelFull + (ctx.afspraak ? ' (' + ctx.afspraak + ')' : ''));

      var h = '<div class="mf-rp__confirm">' +
        '<div class="mf-rp__confirm-check">✓</div>' +
        '<h2 class="mf-rp__confirm-title">Bedankt' + (ctx.naam ? ', ' + esc(ctx.naam.split(' ')[0]) : '') + '! Je afspraak is bevestigd.</h2>' +
        '<p class="mf-rp__confirm-text">We hebben je afspraak ontvangen en je krijgt een bevestiging per e-mail. Tot snel in onze winkel!</p>' +
        '<div class="mf-rp__confirm-card">' +
        '<div class="mf-rp__confirm-row"><span>Toestel</span><b>' + esc(ctx.modelFull + (ctx.color ? ' · ' + ctx.color : '')) + '</b></div>' +
        ctx.items.map(function (it) { return '<div class="mf-rp__confirm-row"><span>Reparatie</span><b>' + esc(it.rname) + (it.dur ? ' · ' + esc(it.dur) + ' min' : '') + '</b></div>'; }).join('') +
        (ctx.afspraak ? '<div class="mf-rp__confirm-row"><span>Afspraak</span><b>' + esc(ctx.afspraak) + '</b></div>' : '') +
        '<div class="mf-rp__confirm-row"><span>Servicemethode</span><b>' + esc(ctx.serviceLabel) + '</b></div>' +
        '<div class="mf-rp__confirm-row mf-rp__confirm-row--total"><span>Totaal incl. btw</span><b>' + esc(ctx.totalStr) + '</b></div>' +
        '</div>' +
        '<div class="mf-rp__confirm-info">' +
        '<div class="mf-rp__confirm-block"><h4>📍 Onze winkel</h4><p><b>Mobielfabriq</b><br>De Raat 32<br>3995 EP Houten</p>' +
        '<a href="' + maps + '" target="_blank" rel="noopener">Bekijk op Google Maps →</a></div>' +
        '<div class="mf-rp__confirm-block"><h4>🕒 Openingstijden</h4><p>Ma t/m vr: 09:30 – 18:00<br>Zaterdag: 09:30 – 17:00<br>Zondag: gesloten</p></div>' +
        '</div>' +
        '<p class="mf-rp__confirm-coffee">We verwelkomen je graag met een vers bakje koffie ☕</p>' +
        '<div class="mf-rp__confirm-btns">' +
        '<a class="mf-rp__btn mf-rp__btn--soft" style="text-decoration:none" target="_blank" rel="noopener" href="https://wa.me/' + esc(waNumber) + '?text=' + waText + '">Stuur ons een WhatsApp-bericht</a>' +
        '<a class="mf-rp__btn mf-rp__btn--primary" style="text-decoration:none" href="/">Terug naar de homepage</a>' +
        '</div></div>';

      body.innerHTML = h;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    /* ---------- start ---------- */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.mf-rp__repair')) {
        root.querySelectorAll('.mf-rp__opts').forEach(function (x) { x.remove(); });
      }
    });

    // Deep-link: ?cat=Smartphone&merk=Apple&model=iPhone 13 -> direct naar de reparatiestap
    // van dat model (gebruikt door de SEO-landingspagina's). Valt terug op normale start.
    function tryDeepLink() {
      var q;
      try { q = new URLSearchParams(location.search); } catch (e) { return false; }
      var mName = q.get('model');
      if (!mName) return false;
      var cat = q.get('cat') || 'Smartphone';
      var brand = q.get('merk') || q.get('brand') || '';
      var lc = function (s) { return (s || '').toLowerCase().trim(); };
      var catObj = (idx.categories || []).filter(function (c) { return lc(c.name) === lc(cat); })[0];
      if (!catObj) return false;
      st.cat = catObj.name;
      var br = idx.brands[st.cat], file;
      if (br && br.direct) { st.brand = ''; file = br.file; }
      else if (Array.isArray(br)) {
        var bObj = br.filter(function (b) { return lc(b.name) === lc(brand); })[0];
        if (!bObj) return false;
        st.brand = bObj.name; file = bObj.file;
      } else { return false; }
      st.brandFile = file;
      loadBrand(file).then(function (data) {
        var m = (data.models || []).filter(function (x) { return lc(x.name) === lc(mName); })[0];
        if (m) { st.model = m; st.color = null; st.items = []; st.showAll = false; renderRepairs(); }
        else { renderTypes(); }
      }).catch(function () { renderTypes(); });
      return true;
    }

    fetchJson(indexUrl).then(function (data) {
      idx = data;
      if (!tryDeepLink()) renderTypes();
    }).catch(function () {
      body.innerHTML = '<div class="mf-rp__loading">De reparatiemodule kon niet laden. Vernieuw de pagina of <a href="https://wa.me/' + esc(waNumber) + '">app ons</a>.</div>';
    });
  }

  function boot() {
    document.querySelectorAll('[data-mf-rp]').forEach(function (el) {
      if (!el._mfInit) { el._mfInit = true; init(el); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
